import { render, staticRenderFns } from "./NotificationsHeader.vue?vue&type=template&id=64bb84ec&"
import script from "./NotificationsHeader.vue?vue&type=script&lang=ts&"
export * from "./NotificationsHeader.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsHeader.vue?vue&type=style&index=0&id=64bb84ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports